import dayjs from "dayjs";
import "dayjs/locale/en"; // import locale
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);
dayjs.locale("en");
dayjs.updateLocale("en", {
  relativeTime: {
    d: "1 day",
    dd: "%d days",
    future: "in %s",
    h: "1 hour",
    hh: "%d hours",
    m: "1 minute",
    M: "1 month",
    mm: "%d minutes",
    MM: "%d months",
    past: "%s ago",
    s: "1 minute",
    y: "1 year",
    yy: "%d years",
  },
});

export { dayjs };
